export const SearchLinksShuffler = () => {
    const searchLinks = document.querySelector('.search__shuffled-links')
    if (searchLinks) {
        searchLinks.shuffleChildren()
        searchLinks.classList.add('search__shuffled-links--done')
    }
}


Element.prototype.shuffleChildren = function () {
    const children = Array.from(this.children)
    children.forEach((child, index) => {
        const randomIndex = Math.floor(Math.random() * (index + 1))
        this.insertBefore(children[index], children[randomIndex])
    })
}
